import { SECTION_NAME } from './constants';
import * as types from './types';

export const initCheckout = (payload) => ({
  type: types.INIT_CHECKOUT,
  payload,
  meta: payload.quoteItems,
});

export const checkout = {
  request: () => ({
    type: types.CHECKOUT_REQUEST,
  }),
  success: (payload) => ({
    type: types.CHECKOUT_SUCCESS,
    payload,
  }),
  error: (error) => ({
    type: types.CHECKOUT_ERROR,
    payload: error,
  }),
};

/**
 * @param {Object} payload.address
 * @param {Function} payload.onEdit
 */
export const validateAddressFlow = (payload) => ({
  type: types.VALIDATE_ADDRESS_FLOW,
  payload,
});

export const validateAddress = {
  request: () => ({
    type: types.VALIDATE_ADDRESS_REQUEST,
  }),
  success: (payload) => ({
    type: types.VALIDATE_ADDRESS_SUCCESS,
    payload,
  }),
  error: (error) => ({
    type: types.VALIDATE_ADDRESS_ERROR,
    payload: error,
  }),
  pickFromSuggested: (payload) => ({
    type: types.VALIDATE_ADDRESS_PICK_FROM_SUGGESTED,
    payload,
  }),
  confirm: (address) => ({
    type: types.VALIDATE_ADDRESS_CONFIRM,
    payload: { address },
  }),
  edit: (address) => ({
    type: types.VALIDATE_ADDRESS_EDIT,
    payload: { address },
  }),
  cancel: () => ({
    type: types.VALIDATE_ADDRESS_CANCEL,
  }),
};

export const fetchShippingRates = {
  request: (cb) => ({
    type: types.FETCH_SHIPPING_RATES_REQUEST,
    payload: { cb: cb || function () {} },
  }),
  success: (payload) => ({
    type: types.FETCH_SHIPPING_RATES_SUCCESS,
    payload,
  }),
  error: (error) => ({
    type: types.FETCH_SHIPPING_RATES_ERROR,
    payload: error,
  }),
};

/**
 *
 * @param {Object} payload.data
 * @param {string} payload.section - Target name
 * @param {Object} payload.nextSection - Next section which should be opened
 */
export const confirmCheckoutData = (payload) => ({
  type: types.CONFIRM_CHECKOUT_DATA,
  payload,
});

/**
 * Expands target section for editing.
 * @param {string} section - Target section
 */
export const editSection = (section) => ({
  type: types.EDIT_SECTION,
  payload: { section },
});

/**
 * Closes target section.
 * @param {string} payload.section - Target section
 */
export const closeSection = (section) => ({
  type: types.CLOSE_SECTION,
  payload: { section },
});

/**
 * @param {bool} payload.useShippingAddress
 */
export const useShippingAddress = (useShippingAddress) =>
  confirmCheckoutData({
    data: { useShippingAddress },
    section: SECTION_NAME.BILLING_INFO,
    nextSection: SECTION_NAME.SUMMARY,
  });
